import React, { useEffect, useState } from "react";
import OcrService from "../../services/ocr_service.service";
import Settings from "../../services/settings.service";
import Translations from "../../services/translation.service";
import CloseIcon from "../../assets/img/iconCloseModalGrey.svg";
import FirebaseAnalytics from "../../services/analytics.service";
import CONSTANTS from "../../services/constants.service";
const subscriptions = [];
const AddressModal = (props) => {
  let areaInitialValue = "";
  let governorInitialValue = "";
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [addressData, setAddressData] = useState(props?.data);
  const [validity, setValidity] = useState(props.valid);
  const [governorList, setGovernorList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  // const [areaLabel, setAreaLabel] = useState("");
  // const [govLabel, setGovLabel] = useState("");

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );
    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  useEffect(() => {
    if (props?.governorateAreasList?.length) {
      const options = props?.governorateAreasList.map((data) => ({
        value: data.Code,
        label: Translations.activeLang === "ar" ? data.NameAr : data.Name,
      }));
      setGovernorList(options);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const addressCopy = {};
    let overallValidity = true;
    for (const [itemKey, item] of Object.entries(addressData)) {
      const value = item.value;
      const valid = OcrService.checkFieldValidity(value, item.validations);

      if (item.key === "77") {
        if (!valid) overallValidity = false;
        getGovernorAreaValue(value);
        // setAreaLabel(areaInitialValue);
        // setGovLabel(governorInitialValue);
        addressCopy[itemKey] = {
          ...item,
          value: areaInitialValue,
          valid: valid,
        };
        for (const [itemKey, item] of Object.entries(addressCopy)) {
          if (item.key === "governorate") {
            if (!governorInitialValue) overallValidity = false;
            addressCopy[itemKey] = {
              ...item,
              value: governorInitialValue,
              valid: governorInitialValue ? true : false,
            };
          }
        }
      } else {
        if (!valid) overallValidity = false;
        addressCopy[itemKey] = {
          ...item,
        };
      }
    }

    setValidity(overallValidity);
    setAddressData(addressCopy);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getGovernorAreaValue = (areaValue) => {
    if (areaValue && props?.governorateAreasList?.length) {
      props.governorateAreasList.forEach((data) => {
        data.Areas.length &&
          data.Areas.forEach((item) => {
            if (item?.NameAr === areaValue || item?.Code === areaValue) {
              getAreaList(data?.Code);
              areaInitialValue = item?.Code;
              governorInitialValue = data?.Code;
            }
          });
      });
    }
  };

  const getAreaList = (governorCode) => {
    if (governorCode && props?.governorateAreasList?.length) {
      props.governorateAreasList.forEach((data) => {
        if (data?.Code === governorCode) {
          const options =
            data?.Areas?.length &&
            data?.Areas.map((data) => ({
              value: data.Code,
              label: Translations.activeLang === "ar" ? data.NameAr : data.Name,
            }));
          setAreaList(options);
        }
      });
    } else {
      setAreaList({
        value: "",
        label: "None",
      });
    }
  };
  const changeHandler = (e, key) => {
    const addressCopy = {};
    let overallValidity = true;
    for (const [itemKey, item] of Object.entries(addressData)) {
      const value = key === item.key ? e.target.value : item.value;
      const valid = OcrService.checkFieldValidity(value, item.validations);
      if (!valid) overallValidity = false;
      if (key === "governorate") {
        if (key === item.key) getAreaList(value);
        addressCopy[itemKey] = {
          ...item,
          value: value,
          valid: valid,
        };
        if (item.key === "77") {
          overallValidity = false;
          addressCopy[itemKey] = {
            ...item,
            value: "",
            valid: false,
          };
        }
      } else {
        if (key === item.key) {
          addressCopy[itemKey] = {
            ...item,
            value: value,
            valid: valid,
          };
        } else {
          addressCopy[itemKey] = {
            ...item,
          };
        }
      }
    }
    setValidity(overallValidity);
    setAddressData(addressCopy);
  };

  // handleSelectGovernor
  const translation_prefix = "kw_ocr_field_type_";
  const mappedData = Object.keys(addressData).map((index) => {
    const objMapped = addressData[index];
    const translatedFieldName =
      translationKeys[translation_prefix + objMapped.key];
    const translatedFieldPlaceholder =
      translationKeys["kw_address_placeholder_" + objMapped.key];
    const requiredField = objMapped.validations?.required ? "*" : "";
    const value = objMapped.value !== "" ? objMapped.value : null;
    const disabled = objMapped?.disabled;
    const valid = objMapped.valid;

    let inputClassNames = value
      ? !valid
        ? "filled invalid"
        : "filled"
      : !valid
        ? "invalid"
        : "";
    return (
      <>
        {objMapped.key === "governorate" ? (
          <div
            className={`generic-field-container form${objMapped.key}`}
            key={objMapped.key}
          >
            <label>
              {translatedFieldName + requiredField}
            </label>
            {/* <div
              className={`select-value-add ${!value ? "drop-down-error" : ""}`}
            >
              {value ? govLabel : `${translatedFieldName + requiredField}`}
            </div> */}
            <select
              className={`storefront-search-input select-component ${!value ? "drop-down-error" : ""}`}
              value={value ? value : ""}
              onChange={(e) => {
                // var index = e.nativeEvent.target.selectedIndex;
                // setGovLabel(e.nativeEvent.target[index].text);
                changeHandler(e, objMapped.key);
              }}
            >
              <option value={""}>{translationKeys["ob_address_none"]}</option>
              {governorList?.length
                ? governorList.map(({ value, label }, index) => (
                  <option value={value}>{label}</option>
                ))
                : null}
            </select>
          </div>
        ) : null}

        {objMapped.key === "77" ? (
          <div
            className={`generic-field-container form${objMapped.key}`}
            key={objMapped.key}
          >
            <label>
              {translatedFieldName + requiredField}
            </label>
            <select
              className={`storefront-search-input select-component ${!value ? "drop-down-error" : ""}`}
              value={value ? value : ""}
              onChange={(e) => {
                var index = e.nativeEvent.target.selectedIndex;
                // setAreaLabel(e.nativeEvent.target[index].text);
                props.setArea(e.nativeEvent.target[index].text);
                changeHandler(e, objMapped.key);
              }}
            >
              <option value={""}>{translationKeys["ob_address_none"]}</option>
              {areaList?.length
                ? areaList.map(({ value, label }, index) => (
                  <option value={value} key={index}>
                    {label}
                  </option>
                ))
                : null}
            </select>
          </div>
        ) : null}

        {objMapped.key !== "governorate" && objMapped.key !== "77" ? (
          <div
            className={`generic-field-container form${objMapped.key}`}
            key={objMapped.key}
          >
            <label>
              {translatedFieldName + requiredField}
            </label>
            <input
              className={"storefront-search-input " + inputClassNames}
              type="text"
              placeholder={translatedFieldPlaceholder}
              value={value ? value : ""}
              onChange={(e) => changeHandler(e, objMapped.key)}
              disabled={disabled}
            // style={
            //   value && !disabled ? {} : { backgroundColor: "transparent" }
            // }
            />
          </div>
        ) : null}
      </>
    );
  });

  return (
    <div className="dialog address-modal">
      <div className="dialog-container ">
        <div className="page-modal">
          <div className="dialog-container-content form-container">
            <div className="heading-btn-container">
              <h1>{translationKeys["kw_adress_customer_name"]}</h1>
              <span onClick={props.open}>
                <img src={CloseIcon} alt="" />
              </span>
            </div>
            <h4>{translationKeys["stf_enter_address_below"]}</h4>
            <div className="address-form addressForm">{mappedData}</div>
            <button
              disabled={!validity && Settings?.enableAddressEdit}
              className="common-button address-btn"
              onClick={() => {
                FirebaseAnalytics.button_clicked(CONSTANTS.OCR_FLOW_SCREEN, "kw_adress_done");
                props.submitAddressData(addressData, validity);
                props.open();
              }}
            >
              {translationKeys["stf_save"]}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressModal;
